import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import cn from 'classnames';
import dayjs from 'dayjs';

import ButtonComponent from '../../../containers/App/Components/Button/Button';

import { setFilterCombination, updateTransportOrderFilter } from '../actions';
import {
  selectQuickFilter,
  selectQuickSeparateFilter,
  selectTransportOrderFilter,
  selectTransportOrderSeparateListFilter,
} from '../selectors';
import styles from './TransportOrderFilter.module.css';

import { QUICK_FILTER, TRANSPORT_ORDER_STATUS } from '../constants';

const Container = styled.div`
  .ranged {
    min-width: ${props => (props.controlWidth ? props.controlWidth : '55%')};
  }

  min-width: ${props => (props.minWidth ? props.minWidth : '')};

  .button-filter-block {
    // position: absolute;
    top: -50px;
    left: 0px;
  }
  .selected {
    background-color: #0183d5 !important;
    color: white !important;
  }
`;

const STATE = {
  selectedValues: [],
  selectedValue: null,
  selectedLabels: [],
  selectedLabel: '',
  altValue: null,
  showOptions: false,
  min: null,
  max: null,
  minDate: null,
  maxDate: null,
  text: '',
  company: null,
  user: null,
  searchLabel: '',
};

/* eslint-disable react/prefer-stateless-function */
class TransportOrderQuickFilterComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps, prevState) {}

  getFilterValueByName(filterName) {
    return this.props.filter.properties?.find(p => p.key === filterName)?.value?.[0];
  }

  reset() {
    this.setState({ ...STATE });
  }

  renderButtonFilter = quickFilter => {
    const combination = quickFilter.combination;
    const filterProps = quickFilter.filter;
    let isSelect = false;
    let title = '';
    const date = dayjs(Date.now()).format('DD-MM-YYYY');
    const statusRequested = this.getFilterValueByName('status') === TRANSPORT_ORDER_STATUS.Requested;
    const statusPlanned = this.getFilterValueByName('status') === TRANSPORT_ORDER_STATUS.Initiated;
    const typeIncoming = this.getFilterValueByName('type') === 'incoming';
    const typeOutgoing = this.getFilterValueByName('type') === 'outgoing';
    const typeOther = this.getFilterValueByName('type') === 'other';
    const finalized = this.getFilterValueByName('outgoing_invoice_finalized') === '1';
    const isFromNL = this.getFilterValueByName('countryFrom') == '156';
    const isFromTodayDateToPlan = this.getFilterValueByName('dateToPlan') === date;

    // Define title and select for Button Filters according to combination strategy
    if (combination === QUICK_FILTER.IncomingAndRequested.combination) {
      title = this.lbl('vehicle.overview.incoming_requested');
      isSelect = statusRequested && typeIncoming && isFromNL && isFromTodayDateToPlan;
    }

    if (combination === QUICK_FILTER.OutgoingAndRequested.combination) {
      title = this.lbl('vehicle.overview.outgoing_requested');
      isSelect = statusRequested && typeOutgoing && finalized && isFromNL;
    }

    if (combination === QUICK_FILTER.PlannedJohn.combination) {
      const transporterId = this.getFilterValueByName('transporterId') === '1';
      title = this.lbl('vehicle.overview.planned_john');
      isSelect = transporterId && statusPlanned;
    }

    if (combination === QUICK_FILTER.PlannedMatthijs.combination) {
      const transporterId = this.getFilterValueByName('transporterId') === '3';
      title = this.lbl('vehicle.overview.planned_matthijs');
      isSelect = transporterId && statusPlanned;
    }

    if (combination === QUICK_FILTER.PlannedDirk.combination) {
      const transporterId = this.getFilterValueByName('transporterId') === '4';
      title = this.lbl('vehicle.overview.Dick');
      isSelect = transporterId && statusPlanned;
    }

    if (combination === QUICK_FILTER.PlannedAlwin.combination) {
      const transporterId = this.getFilterValueByName('transporterId') === '2';
      title = this.lbl('vehicle.overview.planned_alwin');
      isSelect = transporterId && statusPlanned;

    }

    if (combination === QUICK_FILTER.PlannedIntern.combination) {
      const transporterId = this.getFilterValueByName('transporterId') === '6';
      title = this.lbl('vehicle.overview.planned_intern');
      isSelect = transporterId && statusPlanned;
    }


    if (combination === QUICK_FILTER.NotNLOutgoingRequested.combination) {
      title = this.lbl('vehicle.overview.not_nl_outgoing_requested');
      isSelect = statusRequested && isFromNL && typeOutgoing;
    }
    if (combination === QUICK_FILTER.NotNLIncomingRequested.combination) {
      title = this.lbl('vehicle.overview.not_nl_incoming_requested');
      isSelect = statusRequested && typeIncoming && isFromNL;
    }
    // if (combination === FILTER_COMBINATIONS.OtherRequested.combination) {
    //   title = this.lbl('vehicle.overview.other_requested');
    //   isSelect = statusRequested && typeOther;
    // }

    const checked = isSelect && this.props.filterCombination === combination;

    return (
      <div className={cn(styles.buttonFilterContainer, 'd-flex gap-2')}>
        <ButtonComponent
          select={checked}
          onClick={() => this.props.setCombination(filterProps, combination)}
          style={
            this.props.overview === 'double'
              ? checked
                ? 'ButtonSelectedStyleDouble'
                : 'ButtonSoftShortSortDouble'
              : checked
              ? 'ButtonSelectedStyle'
              : 'ButtonSoftShortSort'
          }
        >
          {title}
        </ButtonComponent>
      </div>
    );
  };

  render() {
    return (
      <Container >
        <div className="row justify-content-start" style={{ width: '200%' }}>
          <div className={cn('button-filter-left', 'd-flex gap-2')}>

          {window.innerWidth >= 1024 && (
              <>
                {this.renderButtonFilter(QUICK_FILTER.IncomingAndRequested)}
                {this.renderButtonFilter(QUICK_FILTER.OutgoingAndRequested)}
                {this.renderButtonFilter(QUICK_FILTER.NotNLOutgoingRequested)}
                {this.renderButtonFilter(QUICK_FILTER.NotNLIncomingRequested)}
              </>
            )}

            {this.renderButtonFilter(QUICK_FILTER.PlannedJohn)}
            {this.renderButtonFilter(QUICK_FILTER.PlannedAlwin)}
            {this.renderButtonFilter(QUICK_FILTER.PlannedMatthijs)}
            {this.renderButtonFilter(QUICK_FILTER.PlannedDirk)}
            {this.renderButtonFilter(QUICK_FILTER.PlannedIntern)}
          </div>
        </div>
      </Container>
    );
  }
}

TransportOrderQuickFilterComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func,
  options: PropTypes.array,
  label: PropTypes.string,
  isBool: PropTypes.bool,
  altKey: PropTypes.string,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    filter: ownProps.separateFilter ? selectTransportOrderSeparateListFilter() : selectTransportOrderFilter(),
    filterCombination: ownProps.separateFilter ? selectQuickSeparateFilter() : selectQuickFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setCombination(props, combination) {
      dispatch(setFilterCombination(props, combination, { separateFilter: ownProps.separateFilter }));
    },
    reset(alt = false, additionalName) {
      dispatch(
        updateTransportOrderFilter(
          null,
          {
            reset: alt ? ownProps.altKey : additionalName || ownProps.name,
          },
          { separateFilter: ownProps.separateFilter },
        ),
      );
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransportOrderQuickFilter = compose(withConnect, withRouter, injectIntl)(TransportOrderQuickFilterComp);
